// ============================================================
// FILE: resources/js/stores/cart.js
// USPATIH GO — Alpine Store: Cart (Keranjang Belanja)
// ============================================================

import Alpine from 'alpinejs';
import axios from '../config/axios.js';

function cartStorageKey() {
  const userId = Alpine.store('auth')?.user?.id;
  return userId ? `cart_count:${userId}` : 'cart_count';
}

function readInitialCount() {
  const key = cartStorageKey();
  const val = localStorage.getItem(key);
  if (val !== null) return parseInt(val, 10) || 0;
  const legacy = localStorage.getItem('cart_count');
  return parseInt(legacy || '0', 10) || 0;
}

Alpine.store('cart', {
  count: 0,
  items: [],

  initCount() {
    this.count = readInitialCount();
  },

  setCount(n) {
    this.count = n;
    const key = cartStorageKey();
    localStorage.setItem(key, String(n));
    localStorage.removeItem('cart_count');
  },

  increment() { this.setCount(this.count + 1); },
  decrement() { this.setCount(Math.max(0, this.count - 1)); },
  clear()     { this.setCount(0); this.items = []; },

  async syncFromApi() {
    const token = localStorage.getItem('uspatih_token');
    if (!token) return;

    try {
      const { data } = await axios.get('/api/v1/cart');
      const count = data.data?.item_count ?? data.data?.items?.length ?? 0;
      this.setCount(count);
    } catch {
      // abaikan jika belum login / token expired
    }
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.store('cart').initCount();
  Alpine.store('cart').syncFromApi();
});
